__turbopack_context__.v({
  "className": "thefuture_3b84fe9c-module__JN0HCa__className",
  "variable": "thefuture_3b84fe9c-module__JN0HCa__variable",
});
